import { DateTime } from 'luxon';
import { getDateTimeFromOther } from './get-date-time-from-other';

export const formatDateTime = (
  date?: string | DateTime | Date | null,
  showTimezone = true,
  separator = ' ',
) => {
  const asDateTime = getDateTimeFromOther(date);
  if (!asDateTime) return null;
  0;
  return asDateTime
    .setZone('America/Chicago')
    .toFormat(`hh:mm a'${separator}'MM/dd/yyyy${showTimezone ? ' ZZZZ' : ''}`);
};
